import { assignIn } from 'lodash';
import CloudInsightsUtil from 'client/CloudInsights/util/CloudInsightsUtil';
import CollectionApi from 'client/api/v2/CollectionApi';

const sanitizeAccountIdStatus = (account) => {
  assignIn(account, {
    _id: account.objectId,
    statusType: CloudInsightsUtil.getAwsAccountState(account),
  });
};

class CloudInsightsAccountsApi extends CollectionApi {
  constructor() {
    super('/api/v2/cloudinsights/accounts', {
      skip: 0,
      limit: 100,
      sort: 'createdAt',
    });
  }

  async fetch(...args) {
    const response = await super.fetch(...args);

    response.accounts.forEach(sanitizeAccountIdStatus);

    const { accounts, totalCount } = response;
    return { results: accounts, totalCount };
  }

  /**
   * Create new account
   * @param {Object} payload [awsAccountId]
   * @returns {Object} [account, cft_url]
   */
  createAccount(payload) {
    return this.axios.post(`${this.baseUrl}`, payload)
      .then((resp) => (resp && resp.data) || {});
  }

  /**
   * Update account status
   * @param {int} objectId
   * @param {Object} payload [isActivated, isValidated]
   * @returns {Object} [account, cft_url]
   */
  updateAccount(objectId, payload) {
    return this.axios.put(`${this.baseUrl}/${objectId}`, payload)
      .then((resp) => (resp && resp.data) || {});
  }
}

export default new CloudInsightsAccountsApi();
